import { ApiKeys, Service } from '../environment';

export const RADAR_KEY = ApiKeys.get(Service.radar);
